import styled, { CSSProperties } from "styled-components";
import { COLORS } from "../../../constants";

const BaseButton = styled.button<{$color?: string;}>`
  display: flex;
  align-items: center;
  gap: 10px;
  border-radius: 10px;
  border: 10px solid transparent;
  background: ${props => `${props.$color || COLORS.PRIMARY}`};
  cursor: pointer;
`;

const Label = styled.p`
  color: ${COLORS.WHITE};
  text-align: center;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: 0;
`;

const Button = ({ title, color, callback, style }: { title: string; callback: () => void; color?: string; style?: CSSProperties }) => {
  return (
    <BaseButton style={style} onClick={callback}>
      <Label>{title}</Label>
    </BaseButton>
  )
}

export default Button;